const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

/** Keyboard-focusable descendants of root, in DOM order: skips hidden, inert and disabled-fieldset controls. */
export function focusables(root: Element | null): HTMLElement[] {
    if (!root) return [];
    return Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE)).filter((el) => {
        if (el.closest('[hidden], [inert]')) return false;
        const fieldset = el.closest('fieldset[disabled]');
        // Controls in a disabled fieldset's first <legend> stay enabled.
        if (fieldset && !fieldset.querySelector(':scope > legend')?.contains(el)) return false;
        // checkVisibility catches display:none/visibility:hidden in browsers (absent in jsdom).
        return typeof el.checkVisibility !== 'function' || el.checkVisibility({ visibilityProperty: true } as CheckVisibilityOptions);
    });
}
